import { ProviderLabels } from './provider-labels';

export const labels: ProviderLabels = {
  provider: 'Stripe',
  environment: {
    live: 'Live',
    test: 'Test',
  },
  coupon: {
    singular: 'Coupon',
    plural: 'Coupons',
    id: 'ID',
  },
  dashboard: {
    login: 'https://dashboard.stripe.com/login',
  },
};
